import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { Button } from '../../../../ui';
import { TextInput } from '../../../../ui/input/text_input/text_input';
import { OrganizationUnit } from '../TreeStructure';

type EditNameModalProps = {
  organizationUnit: OrganizationUnit | undefined;
  editName: (unitName: string) => void;
};

export const EditNameModal = ({
  organizationUnit,
  editName,
}: EditNameModalProps) => {
  const [newName, setNewName] = useState<string>('');

  return (
    <Stack spacing={2.5} sx={{ my: 1.5 }}>
      <TextInput
        name='currentName'
        value={organizationUnit?.unitName || ''}
        type='text'
        label='Current Name'
        disabled={true}
        onChange={() => {}}
      />
      <TextInput
        name='newName'
        value={newName}
        type='text'
        label='New Name'
        onChange={(event) => setNewName(event.target.value)}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          onClick={() => editName(newName)}
          variant='primary'
          label='Edit Name'
          disabled={newName.length === 0}
        />
      </Box>
    </Stack>
  );
};
